/* eslint-disable object-property-newline */
export const YESNO = [
  {
    label: "YES",
    value: "yes" 
  },
  {
    label: "NO",
    value: "no" 
  },
];

export const TITLES = ["Mr", "Mrs", "Miss", "Ms", "Dr"];
export const BASE_EMAIL_FIELDS = [
  { label: "CP Url", value: "cpUrl", },
  { label: "CRM Url", value: "crmUrl", },
  { label: "Customer Support Name", value: "customerSupportName", },
  { label: "First Name", value: "firstName", },
  { label: "Last Name", value: "lastName", },
];
export const EMAIL_FIELDS = [
  ...BASE_EMAIL_FIELDS,
  { label: "Email", value: "email" },
  { label: "Amount", value: "amount" },
  { label: "Currency", value: "currency" },
  { label: "Reset Link", value: "resetLink" },
  { label: "Account Login", value: "login" },
  { label: "Account Login To", value: "loginTo" },
  { label: "Platform", value: "platform" },
  { label: "Password", value: "password" },
  { label: "Investor Password", value: "investorPassword" },
  { label: "Password Type", value: "type" },
  { label: "Gateway", value: "gateway" },
  { label: "Amount", value: "amount" },
  { label: "Rejection Reason", value: "rejectionReason" },
  { label: "PIN", value: "pin" },
  { label: "From Details", value: "from" },
  { label: "To Details", value: "to" },
  { label: "Platform Link", value: "platformLink" },
  { label: "Live Server", value: "liveServer" },
  { label: "Demo Server", value: "demoServer" },
  { label: "Profile Type", value: "profileType" },
  { label: "Status", value: "status" },
  { label: "Date", value: "date" },
  { label: "Time", value: "time" },
  { label: "Message", value: "message" },
  { label: "Error", value: "error" },
  { label: "Error Details", value: "errorDetails" },
  { label: "Client Id", value: "clientId" },
  { label: "Transaction Id", value: "transactionId" },
  { label: "Transaction Type", value: "transactionType" },
  { label: "Reason", value: "reason" },
];
